export default __webpack_public_path__ + "static/media/PennisulaMap.50fe1024.jpg";